import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'
import { filter, find, findKey, orderBy } from 'lodash'
import firebase from 'firebase/app'

// initial state
const state = {
  all: {},
  hour: {},
  currentHour: {},
}

// getters
const getters = {
  getAll: (state) => () => {
    if (state.all === null) {
      return []
    }
    return Object.values(state.all)
  },
  getQuestionsForHour: (state) => (hourNumber) => {
    if (!hourNumber) return undefined
    if (!state.hour) return undefined

    return state.hour
  },
  openQuestionsForHour: (state) => (hourNumber) => {
    if (!hourNumber) return undefined
    if (!state.hour) return undefined

    return filter(state.hour, function (o, i) {
      o.id = i
      return o.open
    })
  },
  currentHourOpenQuestions: (state) => (hourNumber) => {
    if (!hourNumber) return undefined
    if (!state.currentHour) return undefined

    return filter(state.currentHour, function (o, i) {
      o.id = i
      return o.open
    })
  },
  currentHourAllQuestions: (state) => () => {
    // if (!hourNumber) return undefined
    if (!state.currentHour) return undefined

    return orderBy(state.currentHour, ['questionNumber'], ['asc'])
  },
  getQuestion: (state) => (hourNumber, questionNumber) => {
    if (!hourNumber || !questionNumber) return undefined
    if (!state.hour) return undefined

    return find(state.hour, function (o) {
      return o.questionNumber === parseInt(questionNumber)
    })
  },
  getQuestionKey: (state) => (hourNumber, questionNumber) => {
    let question = parseInt(questionNumber)
    let keys = Object.keys(state.hour)
    let matchedKey = filter(keys, function (o) {
      return state.hour[o].questionNumber === question
    })
    return matchedKey[0]
  },
}

// actions
const actions = {
  bindAllQuestions: firebaseAction(context => {
    return context.bindFirebaseRef('all', db.ref('questions'))
  }),
  bindHourQuestions: firebaseAction((context, hourNumber) => {
    return context.bindFirebaseRef('hour', db.ref(`questions/hour${hourNumber}`))
  }),
  bindCurrentHour: firebaseAction((context, hourNumber) => {
    return context.bindFirebaseRef('currentHour', db.ref(`questions/hour${hourNumber}`))
  }),
  addQuestion: ({ commit }, questionDetails) => {
    questionDetails.createdAt = firebase.database.ServerValue.TIMESTAMP
    db.ref(`questions/hour${questionDetails.hourNumber}`).push(questionDetails)
  },
  saveQuestionText: ({ commit }, { questionText, questionHour, questionKey }) => {
    db.ref(`questions/hour${questionHour}/${questionKey}`).update({ text: questionText })
  },
  toggleOpen: ({ commit }, { hourNumber: hour, questionKey: question, open: toggle }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ open: toggle })
  },
  toggleCorrect: ({ commit }, { hourNumber: hour, questionKey: question, correct: toggle }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ correct: toggle })
  },
  toggleOneDone: ({ commit }, { hourNumber: hour, questionKey: question, oneDone: toggle }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ oneDone: toggle })
  },
  toggleIsAudio: ({ commit }, { hourNumber: hour, questionKey: question, isAudio: toggle }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ isAudio: toggle })
  },
  toggleOneDoneSubmitted: ({ commit }, { hourNumber: hour, questionKey: question, oneDoneSubmitted: toggle }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ oneDoneSubmitted: toggle })
  },
  toggleTeamEffort: ({ commit }, { hourNumber, questionKey, effort }) => {
    db.ref(`questions/hour${hourNumber}/${questionKey}`).update({ teamEffort: effort })
  },
  addToActivePants: ({ commit }, { hourNumber, questionKey, username }) => {
    let userKey = findKey(state.hour[questionKey].activeParticiPants, function (o) { return o === username })
    if (!userKey) {
      db.ref(`questions/hour${hourNumber}/${questionKey}/activeParticiPants`).push(username)
    }
  },
  removeFromActivePants: ({ commit }, { question, username }) => {
    let questionKey = findKey(state.hour, ['questionNumber', question.questionNumber])
    let userKey = findKey(state.hour[questionKey].activeParticiPants, function (o) { return o === username })
    db.ref(`questions/hour${question.hourNumber}/${questionKey}/activeParticiPants/${userKey}`).remove()
  },
  updateQuestionPointValue: ({ commit }, { hourNumber: hour, questionKey: question, pointValue: points }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ pointValue: points })
  },
  updateQuestionAudioUrl: ({ commit }, { hourNumber: hour, questionKey: question, audioUrl: url }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ audioUrl: url })
  },
  updateQuestionSolution: ({ commit }, { hourNumber: hour, questionKey: question, propertyName: property, value: val }) => {
    db.ref(`questions/hour${hour}/${question}/solution`).update({ [property]: val })
  },
  updateVisualOnQuestion: ({ commit }, { hourNumber: hour, questionKey: question, visual: visualObj }) => {
    db.ref(`questions/hour${hour}/${question}`).update({ visual: visualObj })
  },
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
